import Notifications from '@/components/Main/header/Notifications.vue';
import AccountSwitcher from '@/components/Main/topbar/AccountSwitcher.vue';

import businessChatRoutes from './business-chat';
import callCenterRoutes from './call-center';
import cloudLinesRoutes from './cloud-lines';
import managementRoutes from './management';
import settingsRoutes from './settings';
import smsRoutes from './sms';

import type { RouteRecordRaw } from '@bv/router';

export type SidebarItem = {
  title: string;
  route: string;
  items?: SidebarItem[];
  permissions?: string | string[];
};

export default {
  path: '',
  name: 'system',
  redirect: { name: 'mng' },
  meta: {
    authenticated: true,
    header: {
      component: AccountSwitcher,
    },
    headerActions: [
      {
        type: 'notifications',
        component: Notifications,
      },
    ],
  },
  children: [managementRoutes, callCenterRoutes, businessChatRoutes, smsRoutes, settingsRoutes, cloudLinesRoutes],
} as RouteRecordRaw;
